import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { push } from "connected-react-router";
import axios from "axios";
import { appConfig } from "../config"
import keycloak from "../keycloak"

import {
  fetchConsignerOptionsSuccess,
  fetchMonthOptionsSuccess,
  fetchSalesReportSuccess,
  fetchSavedReportsSuccess
} from "../actions/Reports";

import {
  FETCH_CONSIGNER_OPTIONS,
  FETCH_MONTH_OPTIONS,
  FETCH_SALES_REPORT,
  FETCH_SAVED_REPORTS
} from "../constants/ActionTypes";

const baseUrl = appConfig.baseApiUrl

const withHeaders = async (block) => {
  return await keycloak.updateToken(20).then(() => (
    block({
      'Authorization': 'Bearer ' + keycloak.token,
      'Csrf-Token': 'nocheck-allow',
      'Content-Type': 'application/json'
      })
  ));
}

const getConsignerOptions = async (data) => {

  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/merchandise/consigners", { headers:  headers })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}

const getMonthOptions = async (data) => {

  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/reports/sales/months", { headers: headers })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}

const getSalesReport = async (data) => {
  console.log("Fetch sales report: ", data);

  const params = data.payload;
  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/reports/sales", { headers: headers, params: params })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}

const getSavedReports = async (data) => {
  const params = data.payload;
  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/reports/saved", { headers: headers })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}



function* fetchConsignerOptionsRequest(data) {
  try {
    const fetched = yield call(getConsignerOptions, data);
    yield put(fetchConsignerOptionsSuccess(fetched));
  } catch (error) {
    console.log(error);
  }
}

function* fetchMonthOptionsRequest(data) {
  try {
    const fetched = yield call(getMonthOptions, data);
    yield put(fetchMonthOptionsSuccess(fetched));
  } catch (error) {
    console.log(error);
  }
}

function* fetchSalesReportRequest(data) {
  try {
    const fetched = yield call(getSalesReport, data);
    yield put(fetchSalesReportSuccess(fetched));
  } catch (error) {
    console.log(error);
  }
}

function* fetchSavedReportsRequest(data) {
  try {
    const fetched = yield call(getSavedReports, data);
    yield put(fetchSavedReportsSuccess(fetched));
  } catch (error) {
    console.log(error);
  }
}


export default function* rootSaga() {
  yield all([
    takeEvery(FETCH_CONSIGNER_OPTIONS, fetchConsignerOptionsRequest),
    takeEvery(FETCH_MONTH_OPTIONS, fetchMonthOptionsRequest),
    takeEvery(FETCH_SAVED_REPORTS, fetchSavedReportsRequest),
    takeEvery(FETCH_SALES_REPORT, fetchSalesReportRequest)
  ]);
}
